export enum CaseParams {
  CaseId = 'caseId',
  HearingId = 'hearingId',
}

export enum CasePaths {
  HearingPlayback = 'hearing-playback',
}
